import React from 'react';
import { ButtonV2 } from '../ButtonV2/ButtonV2';
import { PulseLoader } from 'react-spinners';

interface AuthButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  text: string;
  actionName?: string;
  type?: 'button' | 'submit' | 'reset';
}

const AuthButton: React.FC<AuthButtonProps> = ({ 
  onClick, 
  disabled = false, 
  isLoading = false, 
  text, 
  actionName,
  type = 'button',
}) => {
  return (
    <div className="flex justify-center w-full">
      {isLoading ? (
        <PulseLoader color="#fda9a9" />
      ) : (
        <ButtonV2
          onClick={onClick}
          disabled={disabled}
          className="w-full bg-as-pink-300 hover:bg-as-pink-500 text-lg text-white font-semibold py-6 px-6 border border-as-pink-300 rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
          actionName={actionName}
          type={type}
        >
          {text}
        </ButtonV2>
      )}
    </div>
  );
};

export default AuthButton; 